// extracted by mini-css-extract-plugin
export default {"tooltipBlock":"style_tooltipBlock__u6be+","header":"style_header__LpoDw","tooltipBlockContent":"style_tooltipBlockContent__TmoKI"};